import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PopoverService } from '@fcom/ui-components';
import { AppState } from '@fcom/core/interfaces';
import { LoginStep } from '@fcom/core-api/login';
import { LoginActions } from '@fcom/core/actions';
import { ConfigService } from '@fcom/core/services';
import { getCurrentBreakPoint } from '@fcom/common/utils/layout.utils';
import { LoginEvent } from '@fcom/common-booking/interfaces/booking-header-interfaces';
import { loginIsOpen } from '@fcom/core/selectors';

import { LoginWidgetComponent, LoginWidgetContext } from '../login-widget/login-widget.component';
import { LoginService } from '../../services';

@Component({
  selector: 'fin-login-dialog',
  templateUrl: './login-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginDialogComponent implements OnInit {
  private loginService = inject(LoginService);
  private store$ = inject<Store<AppState>>(Store);
  private configService = inject(ConfigService);
  private popoverService = inject(PopoverService);

  @ViewChild('loginWidget', { static: true }) loginWidget: LoginWidgetComponent;

  @Input()
  context: LoginWidgetContext;

  loginOpen$: Observable<boolean>;
  mobileOrTablet: boolean;

  toggleLogin(loginEvent: LoginEvent): void {
    this.popoverService.close();
    const currentBreakpoint = getCurrentBreakPoint();

    loginEvent.event.stopPropagation();

    this.mobileOrTablet = ['mobile', 'tablet'].includes(currentBreakpoint);
    if (loginEvent.loggedIn || this.mobileOrTablet) {
      this.loginWidget.open();
    } else if (this.configService.cfg.enableLoginDialog) {
      this.store$.dispatch(LoginActions.setLoginPhaseStep({ step: LoginStep.CREDENTIALS }));
    } else {
      this.loginService.redirectToLogin();
    }
  }

  ngOnInit(): void {
    this.loginOpen$ = this.store$.pipe(loginIsOpen());
  }
}
